import Cookies from 'js-cookie';

const COOKIE_KEY = 'DEV_ENVIRONMENT';

const RUNTIME_ENV_TO_DEV_NAME = {
    staging: 'STAGING',
    preproduction: 'PREPRODUCTION',
};

export const DEV_ENVIRONMENTS = [
    {
        name: 'PRODUCTION',
        config: {
            S200UKI_CONNECTOR_BASE_URL: 'https://connectors-pro01.forcemanager.com',
            NEW_API_URL: 'https://be-services.forcemanager.net/api',
            API_URL: 'https://proxy-pro.forcemanager.com',
            B2_URL: 'https://be-pro.forcemanager.net',
            FORCE_BI_URL: 'https://fmbusinessintelligence.forcemanager.net/api',
            GOOGLE_MAPS_API_KEY: 'AIzaSyCPAkvsFL1NBHJnuHrO23YzpJDSCVBZYdw',
        },
    },
    {
        name: 'PREPRODUCTION',
        config: {
            S200UKI_CONNECTOR_BASE_URL: 'https://connectors-pre.forcemanager.com',
            NEW_API_URL: 'https://be-servicespre.forcemanager.net/api',
            API_URL: 'https://proxy-pre.forcemanager.com',
            B2_URL: 'https://be-pre.forcemanager.net',
            FORCE_BI_URL: 'https://fmbusinessintelligence-pre.forcemanager.net/api',
            GOOGLE_MAPS_API_KEY: 'AIzaSyDI7JCJSoTHZWvqha1Y7fIXSwAMiO6UMlI',
        },
    },
    {
        name: 'STAGING',
        config: {
            S200UKI_CONNECTOR_BASE_URL: 'https://connectors-sta.forcemanager.com',
            NEW_API_URL: 'https://be-servicessta.forcemanager.net/api',
            API_URL: 'https://proxy-sta.forcemanager.com',
            B2_URL: 'https://be-sta.forcemanager.net',
            FORCE_BI_URL: 'https://fmbusinessintelligence-sta.forcemanager.net/api',
            GOOGLE_MAPS_API_KEY: 'AIzaSyDI7JCJSoTHZWvqha1Y7fIXSwAMiO6UMlI',
        },
    },
    {
        name: 'LOCAL',
        config: {
            S200UKI_CONNECTOR_BASE_URL: 'https://connectors-pre.forcemanager.com',
            NEW_API_URL: 'https://be-servicespre.forcemanager.net/api',
            API_URL: 'http://localhost:8080',
            B2_URL: 'https://be-pre.forcemanager.net',
            FORCE_BI_URL: 'https://fmbusinessintelligence-pre.forcemanager.net/api',
            GOOGLE_MAPS_API_KEY: 'AIzaSyDI7JCJSoTHZWvqha1Y7fIXSwAMiO6UMlI',
        },
    },
];

const getRuntimeEnv = () => window?.FM_CONFIG?.ENV || process.env.ENV;

/** Runtime ENV from FM_CONFIG (deploy) or process.env (local). Never trust build-time alone. */
export const isDevEnvironmentSwitcherEnabled = () => {
    if (process.env.NODE_ENV === 'development') return true;

    const env = getRuntimeEnv();
    return env === 'staging' || env === 'preproduction';
};

/** LOCAL only makes sense when running the app locally (pnpm start). */
export const getAvailableDevEnvironments = () => {
    if (process.env.NODE_ENV === 'development') return DEV_ENVIRONMENTS;
    return DEV_ENVIRONMENTS.filter((env) => env.name !== 'LOCAL');
};

export const getDefaultDevEnvironmentName = () => {
    if (process.env.NODE_ENV === 'development') return 'PREPRODUCTION';

    return RUNTIME_ENV_TO_DEV_NAME[getRuntimeEnv()] || null;
};

export const getDevEnvironmentOverride = () => Cookies.get(COOKIE_KEY) || '';

/** Selected env in the switcher: manual override or deploy default. */
export const getActiveDevEnvironment = () =>
    getDevEnvironmentOverride() || getDefaultDevEnvironmentName();

/** True when the user picked a different backend than the deploy default. */
export const hasDevEnvironmentOverride = () => Boolean(getDevEnvironmentOverride());

export const loadDevEnvironment = (key) => {
    if (!isDevEnvironmentSwitcherEnabled()) return;

    const override = key || getDevEnvironmentOverride();
    if (!override && process.env.NODE_ENV !== 'development') return;

    const configKey = override || getDefaultDevEnvironmentName();
    if (!configKey) return;

    window.FM_CONFIG = {
        ...(window.FM_CONFIG || {}),
        ...(DEV_ENVIRONMENTS.find((item) => configKey === item.name)?.config || {}),
    };
};

/** @deprecated Use getDevEnvironmentOverride */
export const getDevEnvironment = () => getDevEnvironmentOverride();

export const setDevEnvironment = (key = '') => {
    const cookieOptions = { path: '/' };

    if (key) {
        Cookies.set(COOKIE_KEY, key, cookieOptions);
        return;
    }

    Cookies.remove(COOKIE_KEY, cookieOptions);
};
